module.exports = __webpack_public_path__ + "img/neumatico.e534e93b.png";